<template>
  <div>
    <strong>{{ columns[level].column.name }}</strong>

    <ul>
      <li
        v-for="(node, idx) in data"
        :key="idx"
      >
        <span
          v-show="node.children"
          class="icon pointer"
          @click="toggle"
        >
          <i
            class="fas"
            :class="isExpanded(idx) ? 'fa-caret-down' : 'fa-caret-right'">
          </i>
        </span>

        <span
          class="pointer"
          @click="toggle(idx)"
        >
          {{ node.value }}
        </span>

        <ul v-if="node.children">
          <tree-item
            v-show="isExpanded(idx)"
            :data="node.children"
            :level="level + 1"
          ></tree-item>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TreeItem',

  props: {
    data: {
      type: Array,
      required: true
    },

    level: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      expanded: []
    }
  },

  computed: {
    ...mapGetters({
      columns: 'columns/columns'
    })
  },

  methods: {
    toggle (idx) {
      if (this.expanded.includes(idx)) {
        this.expanded = this.expanded.filter(x => x !== idx)
      } else {
        this.expanded.push(idx)
      }
    },

    isExpanded (idx) {
      return this.expanded.includes(idx)
    }
  }
}
</script>

<style scoped>
  li > ul {
    margin-left: 2rem;
  }
</style>
